export const DEFAULT_PROMPT_BASED_REPORT = {
  id: 1,
  userQuestion: '',
  report: ''
};
